import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { de, en, es, pt } from 'vuetify/locale'
import i18n from '@/i18n'
import '@/sass/typography.scss'
import '@/sass/overrides.sass'
import '@/sass/custom.scss'

const colors = {
  primary: '#329c36',
  secondary: '#9C27b0',
  accent: '#9C27b0',
  info: '#00CAE3',
  footer: '#353535',
}

const vuetify = createVuetify({
  components,
  directives,
  // Restore the Vuetify 2 defaults that changed in v3. These apply only where a component
  // does not state the prop itself, so the explicit variant="outlined" / density="compact"
  // conversions from the component sweep still win.
  //   - inputs defaulted to the underlined style in v2; v3 defaults to "filled"
  //   - selection controls defaulted to the primary colour in v2; v3 leaves them unstyled
  defaults: {
    VTextField: { variant: 'underlined' },
    VTextarea: { variant: 'underlined' },
    VSelect: { variant: 'underlined', itemColor: 'primary', menuProps: { offset: -40 }, listProps: { density: 'compact' } },
    VAutocomplete: { variant: 'underlined', itemColor: 'primary', menuProps: { offset: -40 }, listProps: { density: 'compact' } },
    VCombobox: { variant: 'underlined', itemColor: 'primary', menuProps: { offset: -40 }, listProps: { density: 'compact' } },
    VFileInput: { variant: 'underlined' },
    // v3's VCardActions injects `{ variant: 'text', slim: true }` into every nested
    // VBtn, so dialog action buttons lost their fill and padding. v2 had no such
    // injection and rendered them as normal coloured buttons.
    VCardActions: {
      VBtn: { variant: 'elevated', slim: false },
    },
    VToolbar: {
      VBtn: { variant: 'elevated' },
    },
    VRadioGroup: { color: 'primary' },
    VRadio: { color: 'primary' },
    VCheckbox: { color: 'primary' },
    VSwitch: { color: 'primary' },
  },
  // Vuetify 2 defaulted to the mdi font set implicitly; Vuetify 3 needs it stated.
  // The @mdi/font stylesheet itself is imported in main.js.
  icons: {
    defaultSet: 'mdi',
  },
  // Vuetify 3's own strings. We deliberately do not use createVueI18nAdapter here:
  // it requires vue-i18n in Composition mode (legacy: false), and this app relies on
  // the Legacy API. syncVuetifyLocale() below keeps the two in step instead.
  locale: {
    locale: i18n.global.locale,
    fallback: 'de',
    messages: { de, en, es, pt, ptBR: pt },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: { colors },
      dark: { colors },
    },
  },
})

// Mirror the app locale onto Vuetify so its built-in strings follow the language switcher.
export function syncVuetifyLocale (locale) {
  vuetify.locale.current.value = locale
}

export default vuetify
